import React, { useEffect, useState } from 'react'
import { Modal, Steps, Form   } from 'antd' 
import { useJKspjdListQuery } from '../../../store/DianShangYeWuApi';
function LoanNodeCheck(props) {
    const {data, isSuccess} = useJKspjdListQuery({jk_spjd_qy_id:props.qy_id,jk_spjd_user_id:props.user_id},{skip:!props.user_id});
    const [items, setItems] = useState([]);
    const [form] = Form.useForm();
    useEffect(() => {
        if(isSuccess && data){
            if(data.Status === 'success' && data.Result){
                const newArr = data.Result.map(item => {
                    const {jk_spjd_id:key,jk_spjd_name,jk_spjd_yh_name,jk_spjd_content,jk_spjd_xuhao,} = item;
                    return {
                        key,
                        title: jk_spjd_name + '：' + jk_spjd_yh_name,
                        content: jk_spjd_content,
                        jk_spjd_xuhao: jk_spjd_xuhao,
                        status: 'wait',
                    }
                })
                const sortArr = newArr.sort( (a, b) => {
                    return a.jk_spjd_xuhao - b.jk_spjd_xuhao;
                })                    
                setItems(sortArr);
                
            } else {
                setItems([]);
            }
        }
    },[data, isSuccess, props.qy_id, props.user_id, props.jk_spjd_user_name])
    const [open, setOpen] = useState(false);    
    return (
        <>
            <a onClick={() => {setOpen(true)}}>{props.jk_spjd_user_name}</a>
            <Modal
                open={open}
                onCancel={() => setOpen(false)}
                onOk={() => {}}
                footer={null}
            >
                <Form 
                    form={form} 
                    layout='horizontal' 
                    labelCol={{ span: 6 }}
                    name={`form_check_${props.jk_spjd_user_id}`}
                >
                    <Form.Item label="借款单操作员" >
                        {props.jk_spjd_user_name}
                    </Form.Item>
                    <Form.Item label="审批点">
                        <div style={{ marginTop: '30px' }}>
                            <style>
                                {`
                                    .ant-steps-item-title {
                                        color: #000 !important;
                                    }
                                `}
                            </style>
                            <Steps
                                items={items}
                                orientation="vertical"  
                                size="small"
                                current={items.length-1}
                            />
                        </div>
                    </Form.Item>                        
                </Form>
            </Modal>
        </>
    )
}
export default LoanNodeCheck